// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gray{color:#292727}.toggle-intl-time .artful-checkbox-wrapper{padding-left:2.5rem;min-height:2.2rem}.toggle-intl-time .artful-checkbox-wrapper label{font-weight:normal}.toggle-intl-time .artful-checkbox-wrapper label:before{top:-0.1rem;font-size:2.2rem}\n", ""]);
// Exports
module.exports = exports;
